import React, { useState } from 'react';
import { storeGetOrDefault, storeSet, DEF_SETTINGS, DEF_STATS } from '../../store';
import '../admin.css';

const Toast = ({ msg, type }) => msg ? <div className={`adm-toast adm-toast-${type}`}>{msg}</div> : null;

const SettingsAdmin = () => {
  const [cfg,   setCfg]   = useState(() => storeGetOrDefault('settings', DEF_SETTINGS));
  const [stats, setStats] = useState(() => storeGetOrDefault('stats',    DEF_STATS));
  const [toast, setToast] = useState({ msg: '', type: 'success' });

  const showToast = (msg, type = 'success') => { setToast({ msg, type }); setTimeout(() => setToast({ msg: '', type: 'success' }), 3000); };

  const saveCfg = (e) => {
    e.preventDefault();
    storeSet('settings', cfg);
    showToast('Settings saved!');
  };

  const saveStats = (e) => {
    e.preventDefault();
    storeSet('stats', stats);
    showToast('Stats saved!');
  };

  const setF    = (k) => (e) => setCfg(c => ({ ...c, [k]: e.target.value }));
  const setStat = (idx, k) => (e) => {
    const list = stats.map((s, i) => i === idx ? { ...s, [k]: e.target.value } : s);
    setStats(list);
  };

  return (
    <div className='adm-page'>
      <Toast {...toast} />
      <div className='adm-header'>
        <div><h1 className='adm-title'>Site Settings</h1><p className='adm-subtitle'>Company information, contact details and homepage stats</p></div>
      </div>

      <div className='adm-settings-grid'>
        {/* Company Info */}
        <form onSubmit={saveCfg}>
          <div className='adm-settings-card'>
            <h3>Company Information</h3>
            <div className='adm-form' style={{ gap: 14 }}>
              {[
                ['companyName','Company Name'],['tagline','Tagline'],
                ['phone','Primary Phone'],['altPhone','Alternate Phone'],
                ['email','Primary Email'],['altEmail','Alternate Email'],
                ['gst','GST Number'],
              ].map(([k, label]) => (
                <div className='adm-form-group' key={k}>
                  <label className='adm-label'>{label}</label>
                  <input className='adm-input' value={cfg[k] || ''} onChange={setF(k)} />
                </div>
              ))}
              <button type='submit' className='adm-btn adm-btn-primary' style={{ marginTop: 8 }}>Save Company Info</button>
            </div>
          </div>
        </form>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
          {/* Addresses */}
          <form onSubmit={saveCfg}>
            <div className='adm-settings-card'>
              <h3>Addresses</h3>
              <div className='adm-form' style={{ gap: 14 }}>
                <div className='adm-form-group'>
                  <label className='adm-label'>HQ Address</label>
                  <textarea className='adm-input adm-textarea' style={{ minHeight: 60 }} value={cfg.hqAddress || ''} onChange={setF('hqAddress')} />
                </div>
                <div className='adm-form-group'>
                  <label className='adm-label'>HQ Phone</label>
                  <input className='adm-input' value={cfg.hqPhone || ''} onChange={setF('hqPhone')} />
                </div>
                <div className='adm-form-group'>
                  <label className='adm-label'>Godown Address</label>
                  <textarea className='adm-input adm-textarea' style={{ minHeight: 60 }} value={cfg.godownAddress || ''} onChange={setF('godownAddress')} />
                </div>
                <div className='adm-form-group'>
                  <label className='adm-label'>Godown Phone</label>
                  <input className='adm-input' value={cfg.godownPhone || ''} onChange={setF('godownPhone')} />
                </div>
                <button type='submit' className='adm-btn adm-btn-primary'>Save Addresses</button>
              </div>
            </div>
          </form>

          {/* Social Links */}
          <form onSubmit={saveCfg}>
            <div className='adm-settings-card'>
              <h3>Social & Contact Links</h3>
              <div className='adm-form' style={{ gap: 14 }}>

                {/* WhatsApp floating button toggle */}
                <div className='adm-form-group'>
                  <label className='adm-label'>WhatsApp Floating Button</label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <button
                      type='button'
                      onClick={() => setCfg(c => ({ ...c, whatsappEnabled: !c.whatsappEnabled }))}
                      style={{
                        padding: '6px 18px', borderRadius: 20, border: 'none', cursor: 'pointer',
                        fontWeight: 700, fontSize: '.8rem',
                        background: cfg.whatsappEnabled ? '#dcfce7' : '#fee2e2',
                        color:      cfg.whatsappEnabled ? '#16a34a' : '#dc2626',
                      }}
                    >
                      {cfg.whatsappEnabled ? '✓ Enabled' : '✗ Disabled'}
                    </button>
                    <span style={{ fontSize: 12, color: '#6b7280' }}>
                      Show / hide the green WhatsApp button on your website
                    </span>
                  </div>
                </div>

                {/* WhatsApp business phone */}
                <div className='adm-form-group'>
                  <label className='adm-label'>WhatsApp Business Number (with country code, digits only)</label>
                  <input
                    className='adm-input'
                    value={cfg.whatsappPhone || ''}
                    onChange={e => {
                      const phone = e.target.value.replace(/\D/g, '');
                      setCfg(c => ({
                        ...c,
                        whatsappPhone: phone,
                        whatsapp: `https://api.whatsapp.com/send?phone=${phone}`,
                      }));
                    }}
                    placeholder='919820325285'
                  />
                  <div style={{ fontSize: 11, color: '#6b7280', marginTop: 4 }}>
                    e.g. 919820325285 (91 = India code, then mobile number)
                  </div>
                </div>

                {[['linkedin','LinkedIn URL'],['facebook','Facebook URL']].map(([k, label]) => (
                  <div className='adm-form-group' key={k}>
                    <label className='adm-label'>{label}</label>
                    <input className='adm-input' value={cfg[k] || ''} onChange={setF(k)} />
                  </div>
                ))}
                <button type='submit' className='adm-btn adm-btn-primary'>Save Social Links</button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* Stats Bar */}
      <form onSubmit={saveStats} style={{ marginTop: 28 }}>
        <div className='adm-settings-card' style={{ maxWidth: '100%' }}>
          <h3>Homepage Stats Bar (shown below the hero slider)</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px,1fr))', gap: 18, marginBottom: 20 }}>
            {stats.map((s, idx) => (
              <div key={s.id} style={{ background: '#f8f9fa', border: '1px solid #e8ecf0', borderRadius: 8, padding: 16 }}>
                <div className='adm-form' style={{ gap: 10 }}>
                  <div className='adm-form-group'>
                    <label className='adm-label'>Value</label>
                    <input className='adm-input' value={s.value} onChange={setStat(idx, 'value')} placeholder='45+' />
                  </div>
                  <div className='adm-form-group'>
                    <label className='adm-label'>Label</label>
                    <input className='adm-input' value={s.label} onChange={setStat(idx, 'label')} placeholder='Years Experience' />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <button type='submit' className='adm-btn adm-btn-primary'>Save Stats</button>
        </div>
      </form>
    </div>
  );
};

export default SettingsAdmin;
